import { ColorOptions } from '@jfs/ui-new'
import { types } from 'mobx-state-tree'
import { ToastPosition, ToastType } from './../../comps/Toast/index'

interface customToastInterface {
  color?: ColorOptions
  message: string
  description: string
  position?: ToastPosition
  toastType?: ToastType
  minWidthOfLeftBox?: number
  onAction?: any
  actionLabel?: any
}

const Response = types
  .model('Response', {
    message: types.optional(types.string, ''),
    description: types.optional(types.string, ''),
    bgColor: types.optional(types.string, ''),
    position: types.optional(types.string, ToastPosition.BOTTOM),
    toastType: types.optional(types.string, ToastType.NEGATIVE),
    minWidthOfLeftBox: types.optional(types.number, 150),
    onAction: types.optional(types.string, ''),
    actionLabel: types.optional(types.string, 'Done'),
  })
  .actions((self) => ({
    setMessage(value: string, description?: string, onAction?: string, actionLabel?: any) {
      self.message = value?.toString() ?? 'Error'
      self.description = description?.toString()
      self.onAction = onAction
      self.actionLabel = actionLabel
      self.toastType = ToastType.NEGATIVE
      self.position = ToastPosition.BOTTOM
      self.bgColor = 'RED'
    },
    resetMessage() {
      self.message = ''
      self.description = ''
      self.onAction = ''
      self.actionLabel = ''
      self.toastType = ToastType.NEGATIVE
    },
    setBgColor(color: ColorOptions) {
      self.bgColor = color
    },
    setToastType(toastType: ToastType) {
      self.toastType = toastType
    },
    setCustomToast({
      color,
      message,
      position,
      toastType,
      minWidthOfLeftBox,
      description,
      onAction,
      actionLabel,
    }: customToastInterface) {
      self.message = message?.toString() ?? 'Error'
      self.description = description?.toString()
      self.onAction = onAction
      self.actionLabel = actionLabel
      self.bgColor = color || 'TRANSPARENT'
      self.position = position || ToastPosition.TOP
      self.toastType = toastType || ToastType.NEGATIVE
      self.minWidthOfLeftBox = minWidthOfLeftBox ?? 200
    },
    resetCustomToast() {
      self.message = ''
      self.description = ''
      self.onAction = ''
      self.actionLabel = ''
      self.position = ToastPosition.BOTTOM
      self.toastType = ToastType.NEGATIVE
      self.minWidthOfLeftBox = 100
    },
  }))
  .views((self) => ({
    getMessage(): any {
      return {
        message: self?.message,
        description: self?.description,
        bgColor: self?.bgColor,
        toastType: self?.toastType ?? ToastType.NEGATIVE,
        position: self?.position ?? ToastPosition.BOTTOM,
        minWidthOfLeftBox: self?.minWidthOfLeftBox,
        onAction: self?.onAction,
        actionLabel: self?.actionLabel,
      }
    },
  }))

export { Response }
